import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/help'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.HelpPageProps>()(Page.Help)
